import { useContext } from 'react';

import BuyerProfileQuizContext from '../utils/buyer_profile_quiz_context';

export default function useBuyerProfileQuizContext() {
  return useContext(BuyerProfileQuizContext) ?? {};
}
